import {
	AddCircle,
	CalendarMonth,
	Description,
	Home,
	MonitorHeart,
	AssignmentTurnedIn,
} from '@mui/icons-material'
// LibraryBooks

export const HOME = 'HOME'
export const CREDENTIALS = 'CREDENTIALS'
export const STAFF = 'STAFF'
export const ABOUT = 'ABOUT'
export const MYPROFILE = 'MYPROFILE'
export const DOCUMENTS = 'DOCUMENTS'
export const CONFIG = 'CONFIG'
export const USER = 'USER'

export const getPathNames = () => {
	return window.location.pathname.split('/')
}
